import React, { useEffect, useState } from 'react';
import { Box, Skeleton, Stack } from '@mui/material';
import ChatMessages from './ChatMessages';
import ChatInput from './ChatInput';

import { useMsal } from '@azure/msal-react';
import { FormattedMessage, useIntl } from 'react-intl';

import { usePostChatMessage } from '../../api/ChatApi';

const DEBUG = false;

const ResultChat = ({ search, searchQuery }) => {
    const intl = useIntl();
    const [text, setText] = useState('');
    const [selectedSessionId, setSelectedSessionId] = useState(null);
    const [newSession, setNewSession] = useState(false);
    const inputPlaceholder = selectedSessionId === null ?
        intl.formatMessage({ id: "chat.input.start" }) :
        intl.formatMessage({ id: "chat.input.continue" });

    useEffect(() => {
        if (newSession && text && text.length > 0) {
            send(text);
            setNewSession(false);
        }
    }, [selectedSessionId]);

    const postChatMessage = usePostChatMessage({
        onSuccess: null,
        onError: null
    });

    if (DEBUG) console.log("ResultChat :: render", search)

    const send = (message) => {
        if (DEBUG) console.log("ResultChat :: send");
        if (DEBUG) console.log(search);
        if (DEBUG) console.log(message);
        //setMessages([...messages, { created: Date.now(), message_content: message, role: 'user' }]);

        if (!searchQuery ||
            !searchQuery.data ||
            !searchQuery.data.result) {
            if (DEBUG) console.error("ResultChat :: send :: searchQuery is not ready");
            return;
        }

        setText('');
        postChatMessage.mutate({
            searchId: search.id,
            chat_session_id: searchQuery.data.result.chat_session.session_id,
            message_content: message
        });
    };

    if (DEBUG) console.log("ResultChat :: searchQuery.data", searchQuery.data);

    return (
        <Box
            style={{
                //marginRight: "auto",
                //marginLeft: "auto",
                //height: "100%",
                textAlign: selectedSessionId === null ?
                    "left" : "left"
            }}>
            <Stack
                direction="column"
                justifyContent="space-between"
                height={null} >
                <Box
                    overflow="auto">
                    {
                        search &&
                        searchQuery?.data?.result?.chat_session?.chat_messages &&
                        <ChatMessages
                            messages={
                                searchQuery
                                    .data.result
                                    .chat_session
                                    .chat_messages
                            } />
                    }
                    {
                        search && searchQuery.isLoading &&
                        <>
                            <Skeleton variant="rectangular" width="100%" height={44} style={{ marginTop: "14px", marginBottom: "14px" }} />
                            <Skeleton variant="rectangular" width="100%" height={44} style={{ marginTop: "14px", marginBottom: "14px" }} />
                            <Skeleton variant="rectangular" width="100%" height={44} style={{ marginTop: "14px", marginBottom: "14px" }} />
                        </>
                    }
                </Box>
                <ChatInput
                    disabled={postChatMessage.isPending}
                    text={text}
                    setText={setText}
                    placeholder={
                        inputPlaceholder
                    }
                    send={send}
                    sending={postChatMessage.isPending}
                    info={
                        <FormattedMessage
                            id="info.chat.results" />
                    }
                />
            </Stack>
        </Box>
    );
};

export default ResultChat;